<ng-template #filtersTemplate>
  <div class="br-flex br-flex-wrap br-gap-2">
    <select class="br-form-select br-form-select--sm br-w-auto" aria-label="Campaign status"
            [ngModel]="filters.status" (ngModelChange)="filter('status', $event)">
      <option value="">All statuses</option>
      <option *ngFor="let status of statuses" [value]="status">{{ statusLabel(status) }}</option>
    </select>
    <select class="br-form-select br-form-select--sm br-w-auto" aria-label="Campaign service line"
            [ngModel]="filters.serviceLine" (ngModelChange)="filter('serviceLine', $event)">
      <option value="">All service lines</option>
      <option *ngFor="let line of serviceLines" [value]="line.value">{{ line.label }}</option>
    </select>
  </div>
</ng-template>
<section class="workspace-page workspace-page--full">
  <header class="workspace-page__heading">
    <h1 class="workspace-page__title">Campaigns</h1>
    <a class="br-btn br-btn--primary br-btn--sm" routerLink="/campaigns/new"
       [hidden]="!auth.hasPermission('Lead.Manage')">New campaign</a>
  </header>
  <p *ngIf="error" class="br-text-danger br-p-3 br-m-0" role="alert">{{ error }}</p>
  <p *ngIf="notice" class="br-text-muted br-p-3 br-m-0" role="status">{{ notice }}</p>
  <ng-container *workspaceView="'full'">
    <div class="workspace-page__body workspace-page__body--contained">
      <app-data-table #table class="workspace-page__panel" [columns]="columns" [rowActions]="auth.hasPermission('Lead.Manage') ? campaignActions : null" [fetch]="fetch" [(search)]="search" [filters]="filters"
                      searchPlaceholder="Find a campaign…" columnPickerKey="campaigns" [resizableColumns]="true"
                      emptyText="No campaigns match. Create a campaign to start planning your promotion.">
        <div dt-filters><ng-container *ngTemplateOutlet="filtersTemplate"></ng-container></div>
        <ng-template dtCell="name" let-row><a class="dt-link" [routerLink]="['/campaigns', row.id]">{{ row.name }}</a></ng-template>
        <ng-template dtCell="serviceLines" let-row>{{ servicesLabel(row.serviceLines) || '—' }}</ng-template>
        <ng-template dtCell="status" let-row>{{ statusLabel(row.status) }}</ng-template>
        <ng-template dtCell="budget" let-row><ng-container *ngIf="row.planning?.budgetAmount != null; else empty">{{ row.planning.budgetAmount | number:'1.2-2' }}</ng-container></ng-template>
        <ng-template dtCell="startsOn" let-row>{{ row.planning?.startsOn || '—' }}</ng-template>
        <ng-template dtCell="endsOn" let-row>{{ row.planning?.endsOn || '—' }}</ng-template>
        <ng-template dtCell="updatedAt" let-row>{{ row.updatedAt | date:'mediumDate' }}</ng-template>
      </app-data-table>
    </div>
  </ng-container>
  <ng-container *workspaceView="'compact'">
    <app-data-list #list [fetch]="fetch" [(search)]="search" [filters]="filters" [trackByFn]="trackById"
                   searchPlaceholder="Find a campaign…" emptyText="No campaigns match. Create a campaign to begin.">
      <div list-filters><ng-container *ngTemplateOutlet="filtersTemplate"></ng-container></div>
      <ng-template dataListItem let-row><strong>{{ row.name }}</strong><div class="br-text-muted">{{ servicesLabel(row.serviceLines) }} · {{ statusLabel(row.status) }}</div></ng-template>
      <ng-template dataListDetail let-row>
        <p *ngIf="row.planning?.serviceOffer">{{ row.planning.serviceOffer }}</p>
        <div>{{ row.planning?.startsOn || 'No start date' }} — {{ row.planning?.endsOn || 'No end date' }}</div>
        <div *ngIf="row.planning?.budgetAmount != null">Budget: {{ row.planning.budgetAmount | number:'1.2-2' }}</div>
        <div class="br-flex br-gap-2 br-mt-2">
          <a class="br-btn br-btn--secondary br-btn--sm" [routerLink]="['/campaigns', row.id]">Open campaign</a>
          <ng-container *ngTemplateOutlet="campaignActions; context: { $implicit: row }"></ng-container>
        </div>
      </ng-template>
    </app-data-list>
  </ng-container>
</section>
<ng-template #campaignActions let-row>
  <button *ngIf="canDelete(row)" type="button" mat-icon-button
          [brMenuTriggerFor]="campaignMenu" [disabled]="deletingId !== null"
          matTooltip="Actions" [attr.aria-label]="'Actions for campaign ' + row.name">
    <br-icon>more_vert</br-icon>
  </button>
  <ng-template #campaignMenu>
    <br-menu [attr.aria-label]="'Actions for campaign ' + row.name">
      <button *ngIf="canDelete(row)" brMenuItem
              [disabled]="deletingId !== null" [attr.aria-label]="'Delete campaign ' + row.name"
              (triggered)="deleteCampaign(row)" label="Delete" icon="delete"></button>
    </br-menu>
  </ng-template>
</ng-template>
<ng-template #empty><span class="br-cell-empty">—</span></ng-template>
